"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectStyled = exports.modifiers = void 0;

var styled_components_1 = __importStar(require("styled-components"));

var styled_components_modifiers_1 = require("styled-components-modifiers");

var atoms_utils_theme_1 = require("@lettucegrow/atoms.utils.theme");

exports.modifiers = {
  inverted: function inverted(_ref) {
    var theme = _ref.theme,
        hasError = _ref.hasError;
    return {
      styles: "\n      select ~ label, .Mui-required {\n        color: ".concat(theme.farmProject.gray_3, ";\n      }\n      select {\n        background: transparent;\n        border-color: ").concat(hasError ? theme.farmProject.error : theme.farmProject.gray_3, ";\n        color: ").concat(theme.farmProject.gray_3, ";\n\n        &:hover,\n        &:active,\n        &:focus {\n          border-color: ").concat(hasError ? theme.farmProject.error : theme.farmProject.brand_primary, ";\n        }\n      }\n    ")
    };
  },
  noSidePadding: function noSidePadding() {
    return {
      styles: "\n      select ~ label, select:focus ~ label {\n        transform: translate(-.75rem,-3.2rem) scale(0.75);\n      }\n      select {\n        padding-left: 0;\n        padding-right: 0;\n      }\n    "
    };
  },
  medium: function medium() {
    return {
      styles: "\n      font-size: 0.875rem;\n      select {\n        font-size: 0.875rem;\n      }\n    "
    };
  },
  compact: function compact(_ref2) {
    var hasValue = _ref2.hasValue;
    return {
      styles: "\n    height: 2.5rem;\n\n    .Icon {\n      top: 1.3rem;\n    }\n    select {\n      height: unset;\n      padding: 0.62rem 1rem 0.62rem 0;\n      line-height: normal;\n\n      &:active,\n      &:focus {\n        ~ label {\n          transform: translate(-0.3rem, -3.55rem) scale(0.75);\n        }\n      }\n\n      ".concat(hasValue ? (0, styled_components_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n              ~ label {\n                transform: translate(-0.3rem, -3.55rem) scale(0.75);\n              }\n            "]))) : (0, styled_components_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n              ~ label {\n                transform: translate(0.75rem, -2.15rem) scale(1);\n              }\n            "]))), "\n    }\n\n    .MuiFormHelperText-root {\n      margin: -1rem 0rem 0.6rem;\n    }\n    ")
    };
  }
};
exports.SelectStyled = styled_components_1.default.div.attrs({
  className: 'SelectStyled'
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 3.5rem;\n  margin: ", ";\n  text-align: left;\n  position: relative;\n\n  .Icon {\n    width: 1rem;\n    height: 1rem;\n    position: absolute;\n    top: 2rem;\n    left: auto;\n    right: 1rem;\n    transform: translate(-50%, -50%);\n    transition: all 0.25s ease-in-out;\n    pointer-events: none;\n  }\n\n  &:active,\n  &:focus,\n  &:focus-within {\n    .Icon {\n      transform: translate(-50%, -50%) rotate(180deg);\n    }\n  }\n\n  select {\n    border: none;\n    border-bottom: ", ";\n    border-radius: 0;\n    background: ", ";\n    border-color: ", ";\n    padding: 1.7rem 0.7rem 0.6rem;\n    width: 100%;\n    height: 3.5rem;\n\n    svg {\n      width: 3rem;\n      height: 3rem;\n    }\n\n    &:hover,\n    &:active,\n    &:focus {\n      box-shadow: none;\n      outline: none;\n      border-width: 2px;\n      border-color: ", ";\n    }\n\n    &:active,\n    &:focus {\n      ~ label {\n        transform: translate(0.3rem, -3.2rem) scale(0.75);\n      }\n    }\n\n    ", "\n  }\n\n  label {\n    font-family: ", ";\n    font-size: 0.75rem;\n    font-weight: 400;\n    text-transform: unset;\n    color: ", ";\n    display: inline-block;\n    transition: transform 300ms;\n    pointer-events: none;\n    text-align: left;\n    letter-spacing: normal;\n  }\n\n  // error text\n  .Text {\n    font-size: 0.75rem;\n    margin-top: -0.8rem;\n  }\n\n  ", ";\n  .MuiFormHelperText-root {\n    margin: -1rem 0.8rem 0.6rem;\n    position: absolute;\n    top: auto;\n    left: auto;\n    bottom: -2.125rem;\n  }\n\n  ", ";\n"])), function (_ref3) {
  var hasError = _ref3.hasError;
  return hasError ? '2rem auto 1rem' : '2rem auto 0.5rem';
}, function (_ref4) {
  var hasError = _ref4.hasError;
  return hasError ? '2px solid' : '1px solid';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.farmProject.gray_2;
}, function (_ref6) {
  var theme = _ref6.theme,
      hasError = _ref6.hasError;
  return hasError ? theme.farmProject.error : theme.farmProject.dark_gray;
}, function (_ref7) {
  var theme = _ref7.theme,
      hasError = _ref7.hasError;
  return hasError ? theme.farmProject.error : theme.farmProject.brand_primary;
}, function (_ref8) {
  var hasValue = _ref8.hasValue;
  return hasValue ? (0, styled_components_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n            ~ label {\n              transform: translate(0.3rem, -3.2rem) scale(0.75);\n            }\n          "]))) : (0, styled_components_1.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n            ~ label {\n              transform: translate(0.75rem, -2.35rem) scale(1);\n            }\n          "])));
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.farmProject.font_family;
}, function (_ref10) {
  var theme = _ref10.theme,
      hasError = _ref10.hasError;
  return hasError ? theme.farmProject.error : theme.farmProject.dark_gray;
}, atoms_utils_theme_1.MuiFormHelperText, (0, styled_components_modifiers_1.applyStyleModifiers)(exports.modifiers));